import { render, staticRenderFns } from "./ActivixTabsMobile.vue?vue&type=template&id=f86d0b72&"
import script from "./ActivixTabsMobile.vue?vue&type=script&lang=js&"
export * from "./ActivixTabsMobile.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports